import classNames from 'classnames';
import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import Footer from '@components/Footer';
import Header from '@components/Header';
import Page from '@components/Page';
import Home from '@pages/Home';
import Locations from '@pages/Locations';
import LocationsParis from '@pages/Locations/LocationsParis';
import Project from '@pages/Project';
import Series from '@pages/Series';
import { gradientBgClassNames } from '@utils/style';
import { IntlContext } from '@utils/useIntl';

const Router = () => {
  const { locale } = useContext(IntlContext);

  return (
    <BrowserRouter>
      <Helmet htmlAttributes={{ lang: locale }}>
        <title>Marc Malignan</title>
      </Helmet>
      <div
        id="base"
        className={classNames(
          gradientBgClassNames,
          'w-full max-w-[1600px] min-h-svh mx-auto flex flex-col font-text font-extralight text-light',
        )}
      >
        <Header />
        <Page>
          <Routes>
            {/* ---------- Pages ---------- */}
            <Route path="/" element={<Home />} />
            <Route path="/locations/paris" element={<LocationsParis />} />
            <Route path="/locations/:zone" element={<Locations />} />
            <Route path="/locations/" element={<Locations />} />
            {/* ---------- Series ---------- */}
            <Route
              path="/series/:seriesId/:photoId"
              element={<Project baseRoute="/series" />}
            />
            <Route
              path="/series/:seriesId"
              element={<Project baseRoute="/series" />}
            />
            <Route path="/series" element={<Series />} />
            {/* ---------- Locations ---------- */}
            <Route
              path="/locations/:zone/:seriesId/:photoId"
              element={<Project baseRoute="/locations" />}
            />
            <Route
              path="/locations/:zone/:seriesId"
              element={<Project baseRoute="/locations" />}
            />
            {/* ---------- Default ---------- */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Page>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default Router;
